<div class="row">
	<div class="col-12 col-lg-3">
		<app-gen-select
			[options]="years"
			[actualObj]="this"
			fieldName="year"
		>
		</app-gen-select>
	</div>
	<div class="col-12 col-lg-3">
		<app-gen-select
			[options]="months"
			[actualObj]="this"
			fieldName="month"
			[errors]="monthErr"
		>
		</app-gen-select>
	</div>
	<div class="col-12 col-lg-3">
		<button
			class="btn btn-primary"
			(click)="loadData()"
		>
			{{ "search" | langVal }}
		</button>
	</div>
</div>
<app-table-wrap
	fieldsStr="followups,user,to_be_paid,sum,confirm_transfer,invoice_number,expensetype,expense_sum,expense_date,confirm_invoice"
	[isResponsive]="false"
>
	@for (row of rows; track row) {
		<tr>
			<td>
				@if (row?.followups?.length) {
					<button
						class="btn btn-primary"
						(click)="row.followupsOpen = !row.followupsOpen"
					>
						{{ "followups" | langVal }}
					</button>
				}
			</td>
			<td>{{ row.userName }}</td>
			<td>{{ row.to_be_paid }}</td>

			@if (row.to_be_paid) {
				@if (row.expense_id) {
					<td>{{ row.sum }}</td>
					<td></td>
					<td>{{ row?.expense?.supplier_invoice }}</td>
					<td>{{ row?.expensetype }}</td>
					<td>{{ row?.expense?.sum }}</td>
					<td>{{ row?.expense?.date | dateFormat }}</td>
					<td></td>
				} @else {
					<td>
						<app-gen-input
							[actualObj]="row"
							fieldName="sum"
							(changeEvent)="changeSum(row)"
							[errors]="row.errors"
						>
						</app-gen-input>
					</td>
					<td>
						<app-btn-ext
							text="confirm_transfer"
							(clickEv)="submitSum(row)"
							[disabled]="!row?.sumFormValid"
							[isSpin]="row.sumSaving"
						/>
					</td>

					@if (row.savedSum) {
						<td>
							<app-gen-input
								[actualObj]="row"
								fieldName="supplier_invoice"
								[errors]="row.errors"
								(changeEvent)="changeExpenseForm(row)"
							>
							</app-gen-input>
						</td>
						<td>
							<div class="form-group flex">
								<app-gen-autocomplete
									title_ph_lang="expensetype"
									[searchStr]="row?.expensetype_name || ''"
									[error]="row.errors.expensetype_id"
									[actualObj]="row"
									fieldName="expensetype_id"
									onClickClearAndShowOpts
									[tabindex]="-1"
									[fuzzySearchableClasses]="['expensetypes']"
									(chosenEvent)="changeExpenseForm(row)"
									(keyUp)="row.expensetype_str = $event?.str || ''"
									hasPlus
									plusLang="add_expensetype"
									(plusClick)="openAddExpensetypeModal(row)"
								></app-gen-autocomplete>
							</div>
						</td>
						<td>
							<app-gen-input
								[actualObj]="row"
								fieldName="expense_sum"
								[errors]="row.errors"
								(changeEvent)="changeExpenseForm(row)"
							>
							</app-gen-input>
						</td>
						<td>
							<app-date-picker
								[actualObj]="row"
								fieldName="date"
								[errors]="row.errors"
								(changeEvent)="changeExpenseForm(row)"
							>
							</app-date-picker>
						</td>

						<td>
							<app-btn-ext
								text="confirm_invoice"
								(clickEv)="submitExpenseForm(row)"
								[disabled]="!row?.expenseFormValid"
								[isSpin]="row.expenseSaving"
							/>
						</td>
					} @else {
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					}
				}
			} @else {
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
			}
		</tr>
		@if (row.followupsOpen) {
			<tr>
				<td colspan="99">
					<div style="width: 40%">
						<app-table-wrap fieldsStr="date,time,name">
							@for (followup of row.followups; track followup) {
								<tr>
									<td>{{ followup.date | dateFormat }}</td>
									<td>{{ followup.time | timeFormat }}</td>
									<td>{{ followup.patient_name }}</td>
								</tr>
							}
						</app-table-wrap>
					</div>
				</td>
			</tr>
		}
	}
</app-table-wrap>
